module.exports = __webpack_public_path__ + "static/media/step3.004b233a.png";